<template>
  <div class="notice mainContainer" v-loading="loading">
    <div v-if="listData.rows.length>0">
      <div class="disFlex noticeevery" v-for="item in listData.rows" style="align-items: center;"
        @click="toggxq(item.id)">
        <div>
          <img v-if="item.img" :src="wjSrc+item.img" />
          <img v-else src="../assets/images/6ad36e9fd101c0aa3f1e4722e6d73fa6.png" />
        </div>
        <div style="width: 100%;flex-direction: column;height: 114px;margin-left: 20px;" class="disFlex between">
          <div class="notice-title">{{item.zname}}</div>
          <div>{{item.description}}</div>
          <div>{{item.createTime}}</div>
        </div>
      </div>
    </div>
    <div v-else style="height: 327px;background-color: #fff;text-align: center;">
      <img style="margin: 113px 0 20px;" src="@/assets/images/nodata.png" />
      <div style="font-size: 18px;color: #999999;">暂无公告</div>
    </div>

    <el-pagination style="margin: 15px;text-align: center;" background @size-change="handleSizeChange"
      @current-change="handleCurrentChange" :current-page="params.page" :page-sizes="[10,15,20, 50, 100, 200]"
      :page-size="params.rows" layout="total, sizes, prev, pager, next, jumper" :total="listData.total">
    </el-pagination>
  </div>
</template>

<script>
  export default {
    name: 'Notice',
    props: ['wjSrc'],
    data() {
      return {
        total: 0,
        list: [],
        params: {
          page: 1,
          rows: 10,
          nocid: 1
        },
        listData: {
          total: 0,
          rows: []
        },
        loading: true
      }
    },
    methods: {
      handleSizeChange: function(val) {
        this.$set(this.params, 'rows', val);
      },
      handleCurrentChange: function(val) {
        this.$set(this.params, 'page', val);
      },
      // 跳转详情
      toggxq: function(id) {
        sessionStorage.setItem('noticeId', id)
        this.$router.push('/NoticeDetail');
      },
      getList: function() {
        this.loading = true;
        // /pub/ktNotify/getlistPage.htm?page=1&rows=10
        this.$axios.get('/kt/wz/ktNotify/getlistPage.htm?' + this.$qs.stringify(this.params), {
          headers: {
            "X-Requested-With": "XMLHttpRequest",
          }
        }).then(res => {
          var data = res.data;
          this.listData = data;
          this.loading = false;
        })
      },
    },
    created: function() {
      this.getList()
    },
    watch: {
      params: { //深度监听，可监听到对象、数组的变化
        handler(val, oldVal) {
          this.getList()
        },
        deep: true //true 深度监听
      }
    }
  }
</script>

<style>
  .notice {
    border-radius: 10px;
    padding: 26px;
  }

  .noticeevery {
    margin-bottom: 48px;
    text-align: left;
    opacity: 1;
    font-size: 14px;
    font-weight: 400;
    color: #9a9a9a;
    line-height: 22px;
    letter-spacing: 1px;
    cursor: pointer;
  }

  .noticeevery img {
    width: 192px;
    height: 114px;
    opacity: 1;
    border-radius: 4px;
  }

  .notice-title {
    opacity: 1;
    font-size: 15px;
    font-weight: 700;
    color: #4a4a4a;
    line-height: 24px;
    letter-spacing: 1px;
  }

  .notice-gglist {
    line-height: 60px;
    border-bottom: 1px solid #EFEFEF;
  }

  .notice .el-pagination.is-background .btn-next,
  .el-pagination.is-background .btn-prev,
  .el-pagination.is-background .el-pager li {
    border-radius: 50%;
  }

  .notice .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #0071BA;
  }
</style>



// WEBPACK FOOTER //
// src/components/Notice.vue